import Vue from 'vue'
import { mapGetters } from 'vuex'
import { EventBus } from '@/services/EventBus'
import Modal from '@/components/modal/Modal.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import Player from '@/components/player/Player.vue'
import InputText from '@/components/inputText/InputText.vue'
import Loader from '@/components/loader/Loader.vue'
import TimeInterval from '@/modules/timeInterval/TimeInterval.vue'
import translates from '@/common/translates'

export default {
    name: 'view-tabs',
    data () {
        return {
            form: {
                name: {
                    name: 'name',
                    validator: { required: true, uniqueTabName: true },
                    placeholder: 'View name'
                }
            },
            saving: null,
            removing: null,
            max: null,
            more: false,
            updating: true,
            full: false,
            limit: false,
            isShowDownload: false,
            camera_list: '',
            isCopy: false
        }
    },
    created() {
        this.$validator.extend('uniqueTabName', {
            getMessage: field => 'uniqueTabName',
            validate: (value) => {
                return (!this.views.some(item => {
                    return value == item.name
                })
                // здесь имена вьюс могут совпадать
                || !this.isCopy && value == this.saving.name)
                && value !== translates.ru['Main View']
                && value !== 'Main View'
            }
        })
    },
    mounted() {
        EventBus.$on('resize:start', () => {
            this.updating = true
        });
        EventBus.$on('resize:end', this.updateTabs);
        EventBus.$on('open:export', this.toggleExport);
    },
    computed: {
        ...mapGetters({
            activeView: 'getActiveView',
            grids: 'getGrids',
            activeGrid: 'getActiveGrid',
            archCnvEnabled: 'getArchCnvEnabled'
        }),

        views() {
            return this.$store.state.views
        },
        
        list() {
            let result = this.views.map(item => {
                this.$set(item, 'menu', false)
                return item
            })
            return {
                tabs: result.slice(0, this.max),
                dropdown: result.slice(this.max)
            }
        },
        downloadCamsView() {
            return this.activeView.cams.filter(cam => cam.privilege !== 1)
        }
    },
    watch: {
        views: {
            immediate: true,
            handler() {
                this.$nextTick(() => {
                    this.updateTabs()
                })
            }
        }
    },
    methods: {
        setMaxTabs() {
            if (this.$refs.list) {
                let items = this.$refs.list.children

                let itemsWidth = [...items].reduce((prev, curr) => {
                    let selector = curr.getElementsByClassName('inner')
                    let el = selector.length ? selector[0] : curr

                    return prev + el.clientWidth
                }, 0)

                this.full = itemsWidth / this.$refs.list.clientWidth > 0.5

                if (items.length && this.$refs.list.clientHeight > items[0].clientHeight) {
                    this.max = this.max - 1
                    this.more = true

                    this.$nextTick(() => {
                        this.setMaxTabs()
                    })
                } else {
                    this.updating = false
                }
            }
        },
        updateTabs() {
            this.updating = true
            this.more = false
            this.max = this.views.length

            setTimeout(() => {
                this.setMaxTabs()
            }, 300)
        },
        select(view) {
            this.$store.commit('setGrid', view.grid)
            this.$router.push({ name: 'views', params: { viewId: view.id } })
        },
        edit(tab, isCopy) {
            this.isCopy = !!isCopy

            if (this.views.length > 10 && (tab.temp || this.isCopy)) {
                this.limit = true
            } else {
                this.form.name.value = tab.temp ? this.getNewName() : tab.name
                this.saving = tab
                if (this.isCopy) {
                    this.saving = { ...this.saving, id: undefined}
                }

                Vue.nextTick(() => {
                    let input = this.$refs['form-name']

                    if (input)
                        input.$emit('focus')
                })

                tab.menu = false
            }
        },
        save(tab) {
            let name = this.form.name.value
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$store.dispatch('saveView', {
                        ...tab,
                        cams: tab.cams.slice(0, this.grids.find(g => g.value == tab.grid).max),
                        name: name ? name : tab.name,
                    }).then((view) => {
                        this.isCopy = false
                        this.form.name.value = null
                        this.saving = null
                        this.$router.push({ name: 'views', params: { viewId: view.id } }, () => {this.$store.commit('setGrid', view.grid)})
                    })
                }
            })
        },
        reset(tab) {
            if (tab.temp) {
                this.$store.commit('resetTempView')
                this.$store.commit('setGrid', 1)
            } else {
                this.$store.dispatch('getViewsData').then(views => {
                    const view = views.find(v => v.id == tab.id)
                    this.$store.commit('setGrid', this.activeView.grid)
                    this.$store.commit('saveView', view)
                    this.$nextTick(() => {
                        EventBus.$emit('views:select')
                    })
                })
            }
            
        },
        removeCamsFromView() {
            this.$store.commit('removeCamFromView', {
                camId: null,
                viewId: this.$store.getters.getActiveView.id
            })
        },
        remove(tab) {
            this.removing = null
            this.$store.dispatch('removeView', tab.id).then(viewId => {

                if (this.views.length === 1 && ! this.views[0].cams.length) {
                    this.$store.commit('resetTempView')
                    this.$store.commit('setGrid', 1)
                }

                if (viewId == this.$route.params.viewId) {
                    this.$router.push({ name: 'views', params: { viewId: this.views[0].id } })
                }
            })
        },
        toggleExport(camera_list = ''){
            this.camera_list = camera_list
            this.isShowDownload = !this.isShowDownload
        },
        onSaveVideo(data) {
            EventBus.$emit('export-files', {
                ...data,
                camera_list: this.camera_list
            })
            this.toggleExport()
        },
        getNewName() {
            let result = 1

            this.views.forEach(item => {
                if (result <= item.id)
                    result = item.id + 1
            })

            return Vue.i18n.translate('View') + ' ' + result
        }
    },
    components: {
        Modal,
        Dropdown,
        InputText,
        Loader,
        TimeInterval
    }
}



// WEBPACK FOOTER //
// ./src/modules/viewTabs/viewTabs.js